import React, { useContext } from "react";
import { useState } from "react";
import { useDeepEffect, useRouterParams } from "../../../abstracts";
import * as fileSaver from "file-saver";
import ExcelImage from "../../../styles/exportimg.PNG";
import {
  LoaderWrapper,
  ManageFeeLayout,
  WarningModal,
} from "../../../components";
import {
  cancelTradeByFeeId,
  downloadFeeTransactionSummaryReport,
  getFeeRunListingDetailsBySearchCriteria,
  getFeeTransactionById,
  getPlanLevelFeeCollectedDetailsAfterTrade,
} from "../../../services";
import { formFields, manageFeeFormNames, usDateFormat } from "../../../utils";
import FeeRunInformationCard from "./FeeRunInformationCard";
import { Button, Image } from "react-bootstrap";
import { manageFeeStore, setFeeTransactionInfo } from "../../../contexts";
import { get } from "lodash";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faExclamationTriangle } from "@fortawesome/pro-solid-svg-icons";
import moment from "moment";
const buttons = [
  {
    label: "Download",
    variant: "secondary",
    onClick: () => {
      downloadFeeTransactionSummaryReport(1)
        .then((response) => {
          var blob = new Blob([response], {
            type:
              "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
          });
          fileSaver.saveAs(
            blob,
            //"PayrollSummary.xlsx"
            `Fee Transaction Summary Report_ ${usDateFormat(new Date())}.xlsx`
          );
        })
        .catch((error) => {});
    },
  },
];

const feeHeader = [
  {
    columnName: "Plan Name and ID",
    width: "25%",
  },
  {
    columnName: "Plan Balance",
    width: "25%",
  },
  {
    columnName: "Total Fee Collected",
    width: "25%",
  },
  {
    columnName: "Total Outstanding Fees",
    width: "25%",
  },
];

const data = [
  {
    Name: "Plan ABC",
    PlanBalance: "$99,800.00",
    FeeCollected: "$100,000",
    Date: "$200",
  },
  {
    Name: "Infinite 401(k) plan",
    PlanBalance: "$400,000.00",
    FeeCollected: "$100,000",
    Date: "$0",
  },
  {
    Name: "Demo Plan",
    PlanBalance: "$400,000.00",
    FeeCollected: "$100,000",
    Date: "$0",
  },
  {
    Name: "Plan XYZ",
    PlanBalance: "$180,000.00",
    FeeCollected: "$100,000",
    Date: "$0",
  },
  {
    Name: "401(k) Plan",
    PlanBalance: "$200,000.00",
    FeeCollected: "$100,000",
    Date: "$0",
  },
  {
    Name: "New Plan",
    PlanBalance: "$410,000.00",
    FeeCollected: "$100,000",
    Date: "$0",
  },
  {
    Name: "SKTest plan",
    PlanBalance: "$450,000.00",
    FeeCollected: "$100,000",
    Date: "$0",
  },
  {
    Name: "Add-Hours plan",
    PlanBalance: "$180,000.00",
    FeeCollected: "$100,000",
    Date: "$0",
  },
];

const FeeRunContainer = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [modalVisible, setModalVisible] = useState(false);
  const { feeTransactionId } = useRouterParams();
  const { state, dispatch } = useContext(manageFeeStore);
  const formName = manageFeeFormNames.MANAGE_SPECIFICATION_INFORMATION;
  const fields = formFields[formName];
  const feeRunId = parseInt(feeTransactionId);
  const apiData = get(state, "api.data", {});
  const feeTransactionDetails = get(apiData, "feeTransactionDetails", {});

  useDeepEffect(() => {
    setIsLoading(true);
    getFeeTransactionById(feeRunId)
      .then((response) => {
        dispatch(setFeeTransactionInfo(response));
        setIsLoading(false);
      })
      .catch((error) => setIsLoading(false));
  }, []);
  // useDeepEffect(() => {
  //   setIsLoading(true);
  //   getPlanLevelFeeCollectedDetailsAfterTrade()
  //     .then((response) => {
  //       setIsLoading(false);
  //       // setFeeRunDetails(response?.feeSpecificationInformationDetails);
  //     })
  //     .catch((error) => {
  //       setIsLoading(false);
  //     });
  // }, []);
  const cancelTrade = (id) => {
    setIsLoading(true);
    cancelTradeByFeeId(id)
      .then((response) => {
        setIsLoading(false);
        if (response) {
          getFeeTransactionById(feeRunId).then((res) => {
            dispatch(setFeeTransactionInfo(res));
          });
        }
      })
      .catch((error) => {
        setIsLoading(false);
      });
  };
  return (
    <ManageFeeLayout
      layoutHeader={"Fee Run Details"}
      className="feeRun-details-card"
    >
      <div className="d-flex justify-content-end">
        {feeTransactionDetails?.feeRunStatus == "AwaitingTrade" && (
          <span
            className="cursor-pointer mr-3 fw-500 ft-14"
            style={{ lineHeight: "19px", color: "#C4061A" }}
            onClick={() => setModalVisible(true)}
          >
            Cancel Trade
          </span>
        )}
        {feeTransactionDetails?.feeRunStatus == "Completed" && (
          <span
            className="mr-2 sort-button cursor-pointer payroll-btns"
            style={{ lineHeight: "19px" }}
            onClick={() => {
              downloadFeeTransactionSummaryReport(1)
                .then((response) => {
                  var blob = new Blob([response], {
                    type:
                      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
                  });
                  fileSaver.saveAs(
                    blob,
                    //"PayrollSummary.xlsx"
                    `Fee Transaction Summary Report_ ${usDateFormat(
                      new Date()
                    )}.xlsx`
                  );
                })
                .catch((error) => {});
            }}
          >
            <Image src={ExcelImage} width="20px" height="20px" />
            <u>Export</u>
          </span>
        )}
      </div>
      <LoaderWrapper isLoading={isLoading}>
        <div className="warning-background ft-14 fw-600">
          <FontAwesomeIcon className="mr-2" icon={faExclamationTriangle} />
          The fee values specified here are reported as of{" "}
          {moment().format("MM/DD/YYYY")} and may change post trading due to
          market fluctuations.
        </div>
        <div
          style={{
            border: "1px solid rgba(0, 0, 0, 0.1)",
            height: "auto",
            borderRadius: "5px",
          }}
        >
          <div style={{ display: "flex" }}>
            {feeHeader.map((header, index) => (
              <div
                className="ml-2 mt-4 fw-500 feeHeaders"
                style={{ width: header.width }}
              >
                {header.columnName}
              </div>
            ))}
          </div>
          <hr></hr>

          {data.map((data, index) => {
            return <FeeRunInformationCard listdata={data} index={index} />;
          })}
        </div>

        <WarningModal show={modalVisible} onHide={() => setModalVisible(false)}>
          <div className="remove-text">
            <h4>Cancel Trade?</h4>
            <p>
              This will cancel processing trade for the transaction. Are you ok
              to proceed?
            </p>
            <Button
              type="button"
              className="remove-btn mr-4"
              onClick={() => cancelTrade(feeRunId)}
            >
              Confirm
            </Button>
            <Button
              className="cancel-btn"
              onClick={() => {
                setModalVisible(false);
              }}
            >
              Cancel
            </Button>
          </div>
        </WarningModal>
      </LoaderWrapper>
    </ManageFeeLayout>
  );
};

export default FeeRunContainer;
